import styled from "styled-components";

export const LockMessage = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 1%;
  left: 10%;
  width: 60%;
  background-color: rgb(180, 0, 0, 0.85);
  color: white;
  padding: 1rem;
  z-index: 1000;

  @media (${({ theme }) => theme.breakpoints.min400}) {
    left: 16%;
  }

  @media (${({ theme }) => theme.breakpoints.min800}) {
    left: 25%;
  }
`;

export const LockTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const LockTitleSpan = styled.span`
  display: flex;
  gap: 0 1.2rem;
  align-items: center;
`;
